import {
  array,
  type InferOutput,
  length,
  maxLength,
  minLength,
  number,
  object,
  optional,
  picklist,
  pipe,
  record,
  string,
  trim,
} from "valibot";

const TemplateAttachment = object({
  id: string(),
  file_name: string(),
  file_metadata: object({ size: number(), mimetype: string() }),
});

export const TemplateNameSchema = object({
  name: pipe(
    string(),
    trim(),
    minLength(1, "Name is required"),
    maxLength(50, "Name can't be more than 50 characters long"),
  ),
});

export const NoteTemplateSchema = object({
  ...TemplateNameSchema.entries,
  type: picklist(["NOTE_TEMPLATE"]),
  message: pipe(
    string(),
    trim(),
    minLength(1, "Message is required"),
    maxLength(300, "Message can't be more than 300 characters long"),
  ),
  ai_descriptors: record(string(), string()),
});

export type NoteTemplateSchemaType = InferOutput<typeof NoteTemplateSchema>;

export const InmailTemplateSchema = object({
  ...TemplateNameSchema.entries,
  type: picklist(["INMAIL_TEMPLATE"]),
  message: pipe(
    string(),
    trim(),
    minLength(1, "Message is required"),
    maxLength(1900, "Message can't be more than 1900 characters long"),
  ),
  subject: pipe(
    string(),
    trim(),
    minLength(1, "Subject is required for InMail templates"),
    maxLength(200, "Subject can't be more than 200 characters long"),
  ),
  ai_descriptors: record(string(), string()),
  attachments: optional(array(TemplateAttachment)),
});

export type InmailTemplateSchemaType = InferOutput<typeof InmailTemplateSchema>;

export const MessageTemplateSchema = object({
  ...TemplateNameSchema.entries,
  type: picklist(["MESSAGE_TEMPLATE"]),
  message: pipe(
    string(),
    trim(),
    minLength(1, "Message is required"),
    maxLength(1900, "Message can't be more than 1900 characters long"),
  ),
  ai_descriptors: record(string(), string()),
  attachments: optional(array(TemplateAttachment)),
});

export type MessageTemplateSchemaType = InferOutput<
  typeof MessageTemplateSchema
>;

export const VoiceTemplateSchema = object({
  ...TemplateNameSchema.entries,
  type: picklist(["VOICE_TEMPLATE"]),
  attachments: pipe(
    array(TemplateAttachment, "Voice recording is required"),
    length(1, "Voice recording is required"),
  ),
});

export type VoiceTemplateSchemaType = InferOutput<typeof VoiceTemplateSchema>;

export type TemplateSchemaType =
  | NoteTemplateSchemaType
  | InmailTemplateSchemaType
  | MessageTemplateSchemaType
  | VoiceTemplateSchemaType;
